<template>
  <div class="protected">
  	<navbar isProtected v-on:activateDraw="initDraw = !initDraw" v-bind:initDraw="initDraw"/>
    <protectedMap v-on:activateDraw="initDraw = !initDraw" v-bind:isDraw="initDraw"/>
    <feedback/>
    <mobFoot/>
  </div>
</template>

<script>
// @ is an alias to /src
import navbar from '@/components/navbar.vue'
import protectedMap from '@/components/protectedMap.vue'
import feedback from '@/components/feedback.vue'
import mobFoot from '@/components/mobFoot.vue'

export default {
  name: 'protected',
  components: {
  	navbar,
    protectedMap,
    feedback,
    mobFoot
  },
  data () {
    return {
        initDraw: false
    }
  }
}
</script>
